import React from 'react';
import { NotificationDisplayServiceV1 } from '@oneaudi/audi-notification-display-service';
import { TrackingServiceV2 } from '@oneaudi/audi-tracking-service';
import { useI18n } from '@oneaudi/i18n-context';
import { readFilterFromLocalStore, useServicesContext, useShareUrl } from '@oneaudi/vtp-shared';
import { trackShareClick } from '../../tracking/quickFiltersTracking';
import { TextLink } from '@oneaudi/unified-web-alpha-components';

export const ShareButton: React.FC = () => {
  const { getAdditionalService } = useServicesContext();
  const notificationDisplayService = getAdditionalService(
    'notification-display-service'
  ) as NotificationDisplayServiceV1;
  const trackingService = getAdditionalService('audi-tracking-service') as TrackingServiceV2;

  const shareResultsLabel = useI18n({
    defaultMessage: '',
    id: 'stockcars.button.share.results.label',
  });
  const shareResultsAriaLabel = useI18n({
    defaultMessage: 'Click to share results',
    id: 'stockcars.button.share.results.arialabel',
  });
  const copySuccessfulNotificationKey = useI18n({
    defaultMessage: 'Link copied.',
    id: 'stockcars.button.share.url.copied.success',
  });

  const copyURLToShare = useShareUrl(notificationDisplayService, copySuccessfulNotificationKey);

  function getShareUrl() {
    const filters = readFilterFromLocalStore();
    if (typeof window !== 'undefined') {
      let baseUrl = window.location.href;
      // remove existing hashes so that only the filters and presets will be shared.
      if (baseUrl.indexOf('#') !== -1) {
        baseUrl = baseUrl.substring(0, baseUrl.indexOf('#'));
      }
      return `${baseUrl}${filters && !window.location.href.includes(filters) ? filters : ''}`;
    }
    return '';
  }

  return (
    <TextLink
      aria-label={shareResultsAriaLabel}
      data-testid="plpResultShare"
      href="#"
      icon="share"
      iconPosition="leading"
      margin={[0, 0, 0, 0]}
      onClick={(event) => {
        event.preventDefault();
        copyURLToShare(getShareUrl());
        trackShareClick(trackingService, shareResultsLabel);
      }}
      rel="noopener"
      size="md"
      title={shareResultsLabel}
      underline={false}
      variant="standalone"
    >
      {shareResultsLabel}
    </TextLink>
  );
};
